export default __webpack_public_path__ + "static/media/poi_emergency_multi.5ee9f1f1.svg";